import React from 'react'
import { Categorie, Overley } from './style'

export default function CourseCategorie(props) {
    return (
        <Categorie>
            <img src={props.image} />
            <Overley>
                <h6>{props.title}</h6>
            </Overley>
        </Categorie>
    )
}
